import { FormBuilder } from '@/components/formBuilder';
import { useRef } from 'react';
import * as Yup from 'yup';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Button,
  ModalHeader,
  ModalFooter,
} from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';

export const KConfirmation = ({
  onSubmit = () => {},
  onClose = () => {},
  submitButtonLabel = 'Submit',
  cancelButtonLabel = 'Cancel',
  submitButtonIsLoading = false,
  title = 'Create Custom Report',
  subTitle = 'Create Custom Report',
  primaryButtonProps = {},
  primaryVariant = 'primary',
  showDeleteInput = true,
}) => {
  const formRef = useRef(null);

  const formConfig = [
    {
      name: 'name',
      type: 'input',
      isRequired: true,
      placeholder: 'Type "DELETE"',
      errorMessage: 'Confirmation message is required',
      isInputSubmit: true,
      validation: Yup.string()
        .oneOf(['DELETE'], `Confirmation message doesn't match`)
        .required('Confirmation message is required'),
    },
  ];

  const formSubmit = (values) => {
    onSubmit();
  };

  const handleInternalSubmit = () => {
    if (showDeleteInput) {
      formRef.current.handleSubmit();
    } else {
      onSubmit();
    }
  };

  return (
    <Modal isOpen={true} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader py="15px">
          <KText color="secondary-900" size="md-medium">
            {title}
          </KText>
          {subTitle && (
            <KText color="secondary-700" size="sm-regular" mt="xs">
              {subTitle}
            </KText>
          )}
        </ModalHeader>
        <ModalBody py="0">
          {showDeleteInput && (
            <FormBuilder
              config={formConfig}
              formRef={formRef}
              initialValues={{}}
              onSubmit={formSubmit}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" mr="12px" onClick={onClose}>
            {cancelButtonLabel}
          </Button>
          <Button
            isLoading={submitButtonIsLoading}
            variant={primaryVariant}
            onClick={handleInternalSubmit}
            isDisabled={false}
            {...primaryButtonProps}
          >
            {submitButtonLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
